import "../styles/genAIJobRoles.css";
import {
  FaRobot,
  FaBrain,
  FaChartLine,
  FaLanguage,
  FaEye,
  FaFlask,
  FaCogs,
  FaMicrochip
} from "react-icons/fa";

export default function AIEngineerJobRoles() {
  const roles = [
    { title: "AI Engineer", icon: <FaRobot /> },
    { title: "Machine Learning Engineer", icon: <FaBrain /> },
    { title: "Data Scientist", icon: <FaChartLine /> },
    { title: "NLP Engineer", icon: <FaLanguage /> },
    { title: "Computer Vision Engineer", icon: <FaEye /> },
    { title: "AI Research Engineer", icon: <FaFlask /> },
    { title: "AI Solutions Architect", icon: <FaCogs /> },
    { title: "Robotics Engineer", icon: <FaMicrochip /> }
  ];

  return (
    <section className="genai-roles-page">
      <div className="roles-container">

        {/* HEADER */}
        <div className="roles-header">
          <h2>
            Program Key <span>Job Roles</span>
          </h2>
          <p>
            Career opportunities after completing the
            <strong> AI Engineer Program</strong>
          </p>
        </div>

        {/* ROLES GRID */}
        <div className="roles-grid">
          {roles.map((role, index) => (
            <div className="role-card" key={index}>
              <div className="role-icon">{role.icon}</div>
              <h4>{role.title}</h4>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}